import styled from "styled-components";
import RemoveSubmitButton from "./RemoveSubmitButton";

export const StyledRemoveSubmitButton = styled(RemoveSubmitButton)`
    margin-left: 20px;
`;
